var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeutschePostIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2420.9 1915.4",
    style: {
      enableBackground: "new 0 0 2420.9 1915.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469.1,1915.4h321.7l324.6-328.3H793.6L469.1,1915.4z M2420.9,272.5l-570.8-142.3c-8,161.4-46.1,393.2-101.9,544.9 c1.1-397.7-312.9-675.6-692.7-675C633,0,296,362.1,376.5,808.8c-67.8-104.5-165.4-332.5-125.3-648L3.9,239.1 C-40,795.2,286,1527.7,1128.4,1528.2C1872.9,1528.5,2375.4,941.8,2420.9,272.5L2420.9,272.5z M1520.4,697.2 c-4.3,252-212.1,452.7-464.1,448.4c-251.7,0-455.8-204.4-455.8-456.1s204.1-456.1,455.8-456.1h15.7 C1324,237.4,1524.7,445.3,1520.4,697.2z M1189.6,1587.2l324.8,328.3h321.4l-324.3-328.3H1189.6z M1623.8,1587.2l324.3,328.3h321.4 l-324.6-328.3H1623.8z M360.3,1587.2L35.2,1915.4h322l324.3-328.3H360.3z",
    fill: "#5555FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeutschePostIcon);
export default __webpack_public_path__ + "static/media/DeutschePostIcon.6dedcb6d5d6271b0f936115e1c4edda7.svg";
export { ForwardRef as ReactComponent };